import { queryOptions } from "@tanstack/react-query"
import { EMPTY_NAVIGATION_CONTENT, type NavigationContent } from "../types/navigationContent"

export const NAVIGATION_QUERY_KEY = ["navigation"] as const

/**
 * Navigation content shared by every page.
 *
 * On pages whose `getServerSideProps`/`getStaticProps` go through
 * `resolveDehydratedState`, this query is prefetched server-side and hydrated,
 * so `data` is available on first render. Everywhere else it is fetched from
 * the API route, and consumers fall back to the hardcoded menus meanwhile.
 */
export function getNavigationQueryOptions() {
    return queryOptions({
        queryKey: NAVIGATION_QUERY_KEY,
        async queryFn(): Promise<NavigationContent> {
            const response = await fetch("/api/navigation")

            if (!response.ok) {
                // Navigation is never worth breaking a page for.
                return EMPTY_NAVIGATION_CONTENT
            }

            return (await response.json()) as NavigationContent
        },
        // Matches the server-side cache TTL: refetching more often would only
        // hit the same cached payload.
        staleTime: 60_000,
        retry: false,
    })
}
